<template>
	<Col>
		<SharedUserItem
			:user="user"
			:key="user.id"
			:workflow="workflow"
			v-for="user in users"
			class="share-list-item"
			:userShareData="getUserShareData(user)"
			:hideVisibilityStatus="hideVisibilityStatus"
		/>
	</Col>
</template>

<script>
import SharedUserItem from '@/components/dialogs/ShareFeatureDialog/ExistingShareList/SharedUserItem.vue';
export default {
	name: 'SharedUsers',
	components: { SharedUserItem },
	props: {
		users: { type: Array },
		workflow: { type: Object },
		sharedData: { type: Array },
		hideVisibilityStatus: { type: Boolean },
	},
	methods: {
		getUserShareData(user) {
			return this.sharedData?.find((u) => u.id === user.user_id);
		},
	},
};
</script>

<style scoped lang="scss"></style>
